namespace advisorop.components.servicer {


    export class CuManagerProductController {

        showAnnuityPanel: boolean = false;
        productChange = false;
        managerId: number;

        managerProduct: domains.IManagerProduct = {};

        managerProducts: domains.IManagerProduct[];
        managerProductTypes: domains.IManagerProductType[] = [];
        selProductType: domains.IManagerProductType;

        annuityTypes: Array<domains.ILOV> = [];
        annuitySubtypes: Array<domains.ILOV> = [];
        selAnnuityType: domains.ILOV;
        selAnnuitySubtype: domains.ILOV;

        externalSystems: domains.IExternalSystem[] = [];
        selExternalSystem: domains.IExternalSystem;

        dgManagerProducts: DevExpress.ui.dxDataGridOptions;

        iAmReady: any; //event when controller has been initialised
        
        reportTemplates: domains.IReportTemplate[];
        selReportTemplate: domains.IReportTemplate;

        lovs: Array<domains.ILOV> = [];

        static $inject = ["servicerService", "generalService"];

        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService) {  
            this.dgManagerProducts = {
                export: {
                    enabled: true,
                    fileName: "ManagerProducts"
                },
                bindingOptions: {
                    dataSource: "vm.managerProducts"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no managers products",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "name", caption: "Name" },
                    { dataField: "productTypeName", caption: "Product Type Name" },
                    { dataField: "managerName", caption: "Manager Name" },
                    { dataField: "statusDescription", caption: "Status" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "175" }
                ]
            };
        }

        setManagerProductStatus(managerProduct: domains.IManagerProduct) {

            let managerProductStatus: domains.Status;

            if (managerProduct.status == domains.Status.ACTIVE)
                managerProductStatus = domains.Status.INACTIVE;
            else {
                managerProductStatus = domains.Status.ACTIVE;
            }

            this.servicerService.setManagerProductStatus(managerProduct, managerProductStatus)
                .then(response => {
                    //var ind = this.firmProducts.indexOf(advisoryFirmProduct);
                    //if (ind >= 0) {
                    //    this.firmProducts.splice(ind, 1);
                    //}
                    toastr.success("Manager product status successfully changed");
                    this.loadManagerProducts(this.managerId);
                }, err => toastr.error("Manager product status has not been changed. " + err.data));
        };

        loadManagerProductTypes(managerId: number): void {
            //console.log("Loading Manager product types...");
            this.servicerService.getManagerProductTypes(managerId)
                .then(response => {
                        this.managerProductTypes = response.data;
                        //console.log(this.managerProductTypes);
                    },
                    err => toastr.error("Cannot fetch Product Types. " + err.data));
        };

        loadManagerProducts(managerId): void {
            this.servicerService.getManagerProductsByManager(managerId)
                .then(response => this.managerProducts = response.data,
                    err => toastr.error("Product list can not be loaded. " + err.data));
        };

        loadAnnuityTypes(): void {
            this.generalService.getLOVs().then(response => this.annuityTypes =
                response.filter(v => v.lovType == domains.LovType.ANNUITY_TYPE))
        };

        loadAnnuitySubtypes(annuityType: number): ng.IPromise<any> {
            return this.generalService.getLOVs()
                .then(response => this.annuitySubtypes =
                    response.filter(v => v.lovType == domains.LovType.ANNUITY_SUBTYPE && v.parentId == annuityType));
        };

        searchReportTemplates(term: string): ng.IPromise<{}> {
            return this.servicerService.searchReportTemplates(term)
                .then(response => response.data);
        };
        onReportTemplateSelect($item, $model, $label, $event)
        {
            if (this.selReportTemplate) {
                this.managerProduct.reportTemplateId = this.selReportTemplate.id;
                this.managerProduct.reportTemplateName = this.selReportTemplate.name;
                this.managerProduct.reportTemplatePlatformDescription = this.selReportTemplate.platformDescription;
            } else
            {
                this.managerProduct.reportTemplateId = null;
                this.managerProduct.reportTemplateName = null;
                this.managerProduct.reportTemplatePlatformDescription = null;
            }
        }

        registerNewProduct() {
            this.managerProduct.id = 0;
            this.managerProduct.managerId = this.managerId;
            this.managerProduct.managerProductTypeId = this.selProductType.id;
            
            if (this.showAnnuityPanel) {
                if (!this.selAnnuityType || !this.selAnnuitySubtype) {
                    toastr.error("Please select Annuity type and subtype for selected product type");
                    return;
                }
                this.managerProduct.annuityType = this.selAnnuityType.value;
                this.managerProduct.annuitySubtype = this.selAnnuitySubtype.value;
            } else {
                this.managerProduct.annuityType = null;
                this.managerProduct.annuitySubtype = null;
            }

            if (this.selExternalSystem && this.selExternalSystem != undefined && this.selExternalSystem != null) {
                this.managerProduct.externalSystem = this.selExternalSystem.id;
                if (this.managerProduct.externalSystemId == null || this.managerProduct.externalSystemId == undefined) {
                    toastr.error("Insert external system ID");
                    return;
                }
            }

            this.servicerService.createManagerProduct(this.managerProduct)
                .then(response => {
                        this.managerProduct = response.data;
                        this.managerProducts.push(this.managerProduct);
                    this.managerProduct = {};

                    this.selExternalSystem = null;
                        toastr.success("New product successfully registred");
                    },
                    err => toastr.error("Product has not been created. " + err.data));
        };

        removeProduct(managerProduct: domains.IManagerProduct) {
            this.servicerService.deleteManagerProduct(managerProduct.id)
                .then(response => {
                        var ind = this.managerProducts.indexOf(managerProduct);
                        if (ind >= 0) {
                            this.managerProducts.splice(ind, 1);
                    }
                    
                        toastr.success("Product has been removed.");
                    },
                    err => toastr.error("Product has not been removed. " + err.data));
        };

     
        productTypeChanged(): void {
            this.showAnnuityPanel = this.selProductType && this.selProductType.productTypeId === 4;
            if (this.showAnnuityPanel) {
                this.loadAnnuityTypes();
            }
            this.selAnnuityType = null;
            this.selAnnuitySubtype = null;
        }
        
        annuityTypeChanged(): void {
            if (this.selAnnuityType) {
                this.loadAnnuitySubtypes(this.selAnnuityType.value)
                    .then(response => {
                        // select subtype
                        if (this.annuitySubtypes.length > 0) {
                            this.selAnnuitySubtype = this.annuitySubtypes[0];
                        } else
                            this.selAnnuitySubtype = null;
                    })
            } else {
                this.selAnnuitySubtype = null;
            }
        };

        editManagerProduct(managerProduct: domains.IManagerProduct): void {
            this.managerProduct = managerProduct;
            this.selProductType = this.managerProductTypes.filter(f => f.productTypeId == this.managerProduct.productTypeId)[0];
            if (this.managerProduct.reportTemplateId) {
                this.selReportTemplate = { name: this.managerProduct.reportTemplateName, platformDescription: this.managerProduct.reportTemplatePlatformDescription, id: this.managerProduct.reportTemplateId };
            } else {
                this.selReportTemplate = null;
            }
            if (this.managerProduct.externalSystemId != null) {
                this.selExternalSystem = this.externalSystems.filter(p => p.id == this.managerProduct.externalSystem)[0];
            } else {
                this.selExternalSystem = null;
            }
            this.productChange = true;
        }

        cancelProductChange(): void {
            this.productChange = false;
            this.managerProduct = null;
            this.selProductType = null;
            this.selReportTemplate = null;
            this.selExternalSystem = null;
        }

        updateProduct(): void {
            if (this.managerProduct) {
                if (this.selReportTemplate) {
                    this.managerProduct.reportTemplateId = this.selReportTemplate.id;
                }

                if (this.selExternalSystem && this.selExternalSystem != undefined && this.selExternalSystem != null) {
                    this.managerProduct.externalSystem = this.selExternalSystem.id;
                    if (this.managerProduct.externalSystemId == null || this.managerProduct.externalSystemId == undefined) {
                        toastr.error("Insert external system ID");
                        return;
                    }
                }

                this.servicerService.updateManagerProduct(this.managerProduct)
                    .then(response => { toastr.info(`Product has been updated!`); this.cancelProductChange(); this.loadManagerProducts(this.managerId); }
                    , err => toastr.error("Product name has not been updated. " + err.data))
            }
        }

        loadExternalSystems() {
            this.generalService.getExternalSystemsByType(domains.ExternalSystemType.BACK_OFFICE).then(data => {
                //console.log(data.data);
                this.externalSystems = data.data;
            });
        }

        $routerOnActivate(next, previous) {
        }

        $onInit(): void {
            this.loadExternalSystems();
            this.iAmReady({ ctrl: this });
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "managerId" && this.managerId > 0) {
                    this.loadManagerProducts(this.managerId);
                    this.loadManagerProductTypes(this.managerId);
                }
            }
        }
    }


    class CuManagerProduct implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                managerId: "<",
                iAmReady: "&",

            };
            this.controller = CuManagerProductController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-manager-product.html";
        }
    }
    angular.module(Constants.APP).component("cuManagerProduct", new CuManagerProduct());
}